import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/store/user'

import {companyRouter} from '@/router/companyRouter.js'
import {goodRouter} from '@/router/goodRouter.js'
import {mainRouter} from '@/router/mainRouter.js'
import {managerRouter} from '@/router/managerRouter.js'
import {reportRouter} from '@/router/reportRouter.js'
import {salesOpportunityRouter} from '@/router/salesOpportunityRouter.js'
import {usertRouter} from '@/router/usertRouter.js'
import {settingRouter} from '@/router/settingRouter.js'

//publish page
import {pubCompanyRouter} from '@/router/publish/pubCompanyRouter.js'
import {pubGoodRouter} from '@/router/publish/pubGoodRouter.js'
import {pubMainRouter} from '@/router/publish/pubMainRouter.js'
import {pubManagerRouter} from '@/router/publish/pubManagerRouter.js'
import {pubSalesOpportunityRouter} from '@/router/publish/pubSalesOpportunityRouter.js'
import {pubReportRouter} from '@/router/publish/pubReportRouter.js'
import {pubSettingRouter} from '@/router/publish/pubSettingRouter.js'
import {pubUsertRouter} from '@/router/publish/pubUsertRouter.js'

const routes = [
  ...companyRouter,
  ...goodRouter,
  ...mainRouter,
  ...managerRouter,
  ...reportRouter,
  ...salesOpportunityRouter,
  ...usertRouter,
  ...settingRouter,
  ...pubCompanyRouter,
  ...pubGoodRouter,
  ...pubMainRouter,
  ...pubManagerRouter,
  ...pubSalesOpportunityRouter,
  ...pubReportRouter,
  ...pubSettingRouter,
  ...pubUsertRouter,
  // 예외처리 (미등록 route 접근 시 404)
  {
    path: '/404',
    name: 'notFound',
    component: () => import('@/views/NotFound.vue'),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404"
  }
];

// 라우터 생성
const router = createRouter({
  history: createWebHistory(),
  routes,
  //라우터 링크 pathname같으면 active  클래스이름
  linkActiveClass: "route-active",
  linkExactActiveClass: "route-active"
});



//라우터 네비게이션 가드
//페이지 이동전 필요한 로직 실행(ex 토큰 유효성체크)
router.beforeEach(async(to, from, next) => {
  const userStore = useUserStore()
  //토큰 없으면 login 페이지로 이동
  if(to.meta.notReqLogin || to.path.includes('/publish')){
    next()
  }else{
    if(!userStore.getToken){
      if(to.name !== 'index'){
        alert('권한이 없습니다.로그인을 해주세요')
      }
      next({path : '/login'})
      return
    }
  }
  const path = to.fullPath.split('/')
  if(userStore.user.authGrpId == 'U' && (path[1] =='rd' ||path[1] =='im' )){
    next({path : '/404'})
  }
  next()
})



// 라우터 추출 (main.js에서 import)
export { router }